export default __webpack_public_path__ + "static/media/0024.c7786da7.png";